export default __webpack_public_path__ + "static/media/ADCMap.a6e7324d.png";